import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { browserHistory, Router } from 'react-router';
import { HttpCode } from './enums/HttpCode';
import { setCurrentUser } from './redux/actions/index';
import Routes from "./Routes";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
import { Config, TokenManager, UserManager } from '@forgerock/javascript-sdk';
import SessionTimeoutManager from './components/Shared/SessionTimeoutManager';
import {getEnvironmentFromHost, getClientIdFromHostname, createUser, updateUser} from './utils/UserUtils';
import Spinner from '../src/components/Shared/Spinner';
import { clearUser } from '../src/utils/FRLogout';

const env = location.host.toLowerCase();
const environment = getEnvironmentFromHost().toUpperCase();

const hostname = window.location?.hostname; 
const clientId = getClientIdFromHostname(hostname, environment);
console.log(hostname,'[cfg] Env:-',environment.toUpperCase(),'client:-',clientId);

Config.set({
    serverConfig: {
        baseUrl: process.env[`REACT_APP_${environment.toUpperCase()}_IAM_URL`],
        timeout: parseFloat(process.env.REACT_APP_TIMEOUT ?? "5000"),
    },
    realmPath: process.env[`REACT_APP_${environment.toUpperCase()}_REALM_PATH`],
    clientId: clientId,
    redirectUri: window.location.origin + process.env[`REACT_APP_${environment.toUpperCase()}_REDIRECT_URI`],
    scope: 'openid profile',
});

function mapDispatchToProps(dispatch) {
    return ({
        setCurrentUser: currentUser => dispatch(setCurrentUser(currentUser)),
    });
}

var reactPlugin = new ReactPlugin();

var key = "";
if (env.indexOf("localhost") > -1 || env.indexOf("qa") > -1)
    key = '7058fe84-a0ee-41af-a74d-5faae58ff504';
else if (env.indexOf("int") > -1)
    key = '3a256e61-e743-4f7a-966d-5786f7b77646';
else if (env.indexOf("stg") > -1)
    key = '6ce2b288-dbc1-48ce-b4f2-b2e4988b411c';
else if (env.indexOf("perf") > -1)
    key = 'f122e474-26e2-4c89-94ce-b4f5d2354064';
else if (env.indexOf("csb") > -1)
    key = 'd40f48c6-1326-4247-bb5e-a65da18b858a';
else
    key = '18c0408f-d92e-4143-843f-ef221ee14caf';


var appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: key,     //use localstorage.environment? 
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        disableCorrelationHeaders: false,
        disableFetchTracking: false,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableCorsCorrelation: false,
        extensions: [reactPlugin],
    }
});
appInsights.loadAppInsights();

axios.interceptors.request.use((config) => {
    const frSdk = localStorage.getItem(`FR-SDK-${clientId}`) ?? '';
    const userID = localStorage.getItem("userID")?? '';

    if (Boolean(frSdk)) {
        let parsedFrSdk;
        try {
            parsedFrSdk = JSON.parse(frSdk);
        } catch (e) {
            // Optionally log the error, or handle as needed
            parsedFrSdk = null;
        }
        if (parsedFrSdk && parsedFrSdk.idToken) {
            config.headers.common['token'] = `${parsedFrSdk.idToken}`;
        }
        //header used to track user data
        if(Boolean(userID)){
            config.headers.common['User-Id'] = userID;

        }
    }
    // //inject token
    // if (localStorage.token) {
    //     config.headers.common['token'] = localStorage.token;
    // }

    //build fully-qualified request url. ignore paths beginning with http.
    if (config.url.indexOf("http") === -1) {
        if (process.env.NODE_ENV === 'development') {
            //memberService API calls
            if (config.url.search("/memberService/v1") === 0) {
                config.url = process.env.REACT_APP_MEMBER_API_URL_DEV + '/' + localStorage.getItem('lineOfBusiness') + config.url.replace('/memberService/v1', '');
            }
            //NLP API calls
            else if (config.url.search("/mrrnlpapi/v1") === 0) {
                var baseUrl = '';
                if (localStorage.Environment === 'prod')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_PROD
                else if (localStorage.Environment === 'int')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
                else if (localStorage.Environment === 'stg' || localStorage.Environment === 'stage')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
                else if (localStorage.Environment === 'qa')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_QA;
                else
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_DEV;

                // var client = localStorage.Client === null || localStorage.Client === undefined ? 'qa' : localStorage.Client;
                var client = sessionStorage.getItem("Client") === null || sessionStorage.getItem("Client") === undefined ? 'qa' : sessionStorage.getItem("Client");
                config.url = baseUrl + '/' + client + '/' + sessionStorage.getItem('lineOfBusiness').toLowerCase() + config.url.replace('/mrrnlpapi/v1', '');
                console.log("mrr-nlp-api url"); console.log(config.url);
            }
            //MRR Service API calls
            else {
                config.url = process.env.REACT_APP_MRR_API_URL_DEV + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/mrrService/v1', '');
            }
        }
        //Non Dev Environments
        else {
            if (config.url.search("/memberService/v1") === 0) {
                console.log("memberService URI");
                config.url = process.env.REACT_APP_MEMBER_API_URL_PROD + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/memberService/v1', '');
            }
            else if (config.url.search("/mrrnlpapi/v1") === 0) {
                var baseUrl = '';
                if (localStorage.Environment === 'prod')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_PROD
                else if (localStorage.Environment === 'int')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
                else if (localStorage.Environment === 'stg' || localStorage.Environment === 'stage')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
                else if (localStorage.Environment === 'qa')
                    baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_QA;

                var client = sessionStorage.getItem("Client");
                config.url = baseUrl + '/' + client + '/' + sessionStorage.getItem('lineOfBusiness').toLowerCase() + config.url.replace('/mrrnlpapi/v1', '');
                console.log("mrr-nlp-api url"); console.log(config.url);
            }
            else {
                console.log("mrrService URI");
                config.url = process.env.REACT_APP_MRR_API_URL_PROD + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/mrrService/v1', '');
            }
        }
    }

    return config;
});

axios.interceptors.response.use(
    (response) => {
        // todo: need to implement timeout logic - see EDPS
        // todo: add token to memberService response headers
        // refresh client-side token
        if (response.headers['token'] && localStorage.token !== response.headers['token']) {
            localStorage.token = response.headers['token'];
        }
        return response;
    },
    (error) => {
        // redirect to /Unauthorized route (if not already there)
        const currentLocation = window.location.href.split('/').pop();
        if (error.response && error.response.status === HttpCode.Unauthorized && currentLocation !== "Unauthorized") {
            window.location.href = "/Unauthorized";

        }
        return Promise.reject(error);
    }
);

class App extends React.Component {
    state = { hydrated: false };
    authHydrate = async (authAction, tokensOptions) => {
        try {
            await TokenManager.getTokens(tokensOptions)
                .then(async () => {
                    await UserManager.getCurrentUser()
                        .then((user) => {
                            localStorage.setItem("username", user.name)
                            localStorage.setItem("useremail", user.email)
                            const parsedUser = createUser(user);
                            updateUser(parsedUser);
                            this.setState({ hydrated: true });

                            //sufficient role check
                            if (!parsedUser || !parsedUser.clientLobRoles) return;

                            const clientNames = Object.keys(parsedUser.clientLobRoles);
                            const currentLocation = window.location.href.split('/').pop();

                            if (clientNames.length === 0 && currentLocation !== "Unauthorized") {
                                window.location.href = "/Unauthorized";
                                localStorage.setItem("insufficientRole", true)
                                return;
                            } else {
                                localStorage.setItem("insufficientRole", false)

                            }

                            // to get CurrentUser
                            const isIntialLogin = !localStorage.getItem("wasLoggedInBefore");
                            const url = isIntialLogin
                                ? "/MRRUser/CurrentUser?isLogin=true"
                                : "/MRRUser/CurrentUser";
                             
                            axios.get(url)
                                .then((response) => {
                                    this.props.setCurrentUser(response.data);
                                    localStorage.setItem("userID", response.data.userID);
                                    // Mark that initial login is complete
                                    localStorage.setItem("wasLoggedInBefore", "true");
                                });

                            // to get client and environment
                            axios.get('/session/portalurl')
                                .then((response) => {
                                    //https://qamrr-mrr.qa.advantasure.com/ https://bcbsm-mrr.int.advantasure.com/
                                    var url = response.data;
                                    console.log("session/portalurl - response.data"); console.log(response.data);
                                    var startIdx = response.data.indexOf('://', 0) + 3;
                                    var endIdx = response.data.indexOf('-', 0)
                                    var client = endIdx !== -1 ? url.substr(startIdx, (endIdx - startIdx)).toLowerCase() : "dev";
                                    var clientLabel = client === 'qamrr' ? 'qa' : client;
                                    localStorage.Client = clientLabel;
                                    sessionStorage.setItem('Client', clientLabel);


                                    //environment
                                    var env = '';
                                    env = response.data.indexOf('prod', 0) > 0 ? 'prod' : (
                                        response.data.indexOf('int', 0) > 0 ? 'int' : (
                                            response.data.indexOf('stage', 0) > 0 || response.data.indexOf('stg', 0) > 0 ? 'stg' : (response.data.indexOf('qa', 0) > 0 ? 'qa' : 'dev')
                                        )

                                    )
                                    localStorage.Environment = env;
                                })
                                .catch((error) => {
                                    localStorage.Client = null;
                                    localStorage.Environment = null;
                                    sessionStorage.setItem('Client', "");
                                    console.log(error);
                                });

                        })
                        .catch((err) => {
                            console.log(err);
                            throw new Error(err.message);
                        });
                })
                .catch((err) => {
                    throw new Error(err.message);
                });
        } catch (err) {
            switch (authAction) {
                case 'authorize':
                    console.error('Authorization failed:', err);
                    this.authHydrate('login', { login: 'redirect' });
                    break;
                case 'login':
                    console.error('Not able to login at the moment:', err);
                    break;
                default:
                    break;
            }
        }
    }
    componentWillMount() {
        const url = new URL(document.location.toString());
        const code = url.searchParams.get('code');
        const state = url.searchParams.get('state');

        if (code && state) {
            this.authHydrate('authorize', { query: { code, state } });
        } else {
            this.authHydrate('login', { login: 'redirect' });
        }

        
    }

    render() {
        if (!this.state.hydrated) {
            return <Spinner/>; // or a spinner
        }
        return (
            <>
                <Router history={browserHistory}>
                    {Routes}
                </Router>
                <SessionTimeoutManager></SessionTimeoutManager>
            </>
        );
    }
}

export default connect(
    null,
    mapDispatchToProps
)(withAITracking(reactPlugin, App));